import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BreadcrumbDefinition } from 'xng-breadcrumb/lib/types';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./documents/documents.module').then(m => m.DocumentsModule),
  },
  {
    path: 'management',
    data: {
      breadcrumb: {
        skip: true,
      } as BreadcrumbDefinition,
    },
    loadChildren: () => import('./management/management.module').then(m => m.ManagementModule),
  },
  {
    path: 'productions',
    data: {
      breadcrumb: {
        skip: true,
      },
    },
    loadChildren: () =>
      import('./production-management/parameters.module').then(m => m.ParametersModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GoliathDocumentsRoutingModule {}
